// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"qo-z","slideIn":"ro-z"};